import $ from './jquery-3.2.1.min';
import variables from './variables';
import conditions from './conditions';
import inhibitors from './inhibitors';
import treatments from './treatments';
import infoContent from './text-content/info-content';
import { TweenLite } from 'gsap';

const publicFunctions = {

	runOffset : function runOffset(){
		publicFunctions.showAllGears();

		publicFunctions.resetTimelines();

		publicFunctions.resetConditionState();

		if(offsetCounter <= 0){
			offsetTimeline.to(factor_12, 3, {rotation:-1080, ease: Power0.easeNone}, 0);
			offsetTimeline.to(grey_gear_01, 3, {rotation:1080, ease: Power0.easeNone, delay: .1}, 0);
			offsetTimeline.to(factor_11, 3, {rotation:-1080, ease: Power0.easeNone, delay: .2}, 0);
			offsetTimeline.to(small_gear_01, 3, {rotation:1080, ease: Power0.easeNone, delay: .3}, 0);
			offsetTimeline.to(factor_09, 3, {rotation:-1080, ease: Power0.easeNone, delay: .4}, 0);
			offsetTimeline.to(grey_gear_02, 3, {rotation:1080, ease: Power0.easeNone, delay: .5}, 0);
			offsetTimeline.to(factor_08, 3, {rotation:-1080, ease: Power0.easeNone, delay: .6}, 0);
			offsetTimeline.to(factor_vW, 3, {rotation:1080, ease: Power0.easeNone, delay: .7}, 0);
			offsetTimeline.to(grey_gear_08, 3, {rotation:1080, ease: Power0.easeNone, delay: .8}, 0);
			offsetTimeline.to(factor_10, 3, {rotation:-1080, ease: Power0.easeNone, delay: .9}, 0);
			offsetTimeline.to(grey_gear_06, 3, {rotation:1080, ease: Power0.easeNone, delay: 1}, 0);
			offsetTimeline.to(grey_gear_03, 3, {rotation:1080, ease: Power0.easeNone, delay: 1.1}, 0);
			offsetTimeline.to(grey_gear_07, 3, {rotation:-1080, ease: Power0.easeNone, delay: 1.2}, 0);
			offsetTimeline.to(factor_05a, 3, {rotation:-1080, ease: Power0.easeNone, delay: 1.3}, 0);
			offsetTimeline.to(grey_gear_04, 3, {rotation:1080, ease: Power0.easeNone, delay: 1.4}, 0);
			offsetTimeline.to(small_gear_02, 3, {rotation:1080, ease: Power0.easeNone, delay: 1.5}, 0);
			offsetTimeline.to(factor_02a, 3, {rotation:-1080, ease: Power0.easeNone, delay: 1.6}, 0);
			offsetTimeline.to(factor_07a, 3, {rotation:-1080, ease: Power0.easeNone, delay: 1.7}, 0);
			offsetTimeline.to(small_gear_03, 3, {rotation:1080, ease: Power0.easeNone, delay: 1.8}, 0);
			offsetTimeline.to(factor_01a, 3, {rotation:-1080, ease: Power0.easeNone, delay: 1.9}, 0);
			offsetTimeline.to(grey_gear_05, 3, {rotation:1080, ease: Power0.easeNone, delay: 2}, 0);
			offsetTimeline.to(factor_13a, 3, {rotation:-1080, ease: Power0.easeNone, delay: 2.1}, 0);
			offsetTimeline.to(small_gear_04, 3, {rotation:1080, ease: Power0.easeNone, delay: 2.2}, 0);
			offsetTimeline.to(factor_CLOT, 3, {rotation:-1080, ease: Power0.easeNone, delay: 2.3}, 0);
		}
		var offsetTimeline2 = new TimelineLite();
		offsetTimeline2.add(offsetTimeline.tweenFromTo(0, 2.3)).add(offsetTimeline.tweenFromTo(2.3, 3, {repeat: -1}));

		var treatments_to_hide = ['btnTrmtAaRF', 'btnTrmtALoRF', 'btnTrmtAHiAPCC', 'btnTrmtAHiFVIIIa', 'btnTrmtBaRF', 'btnTrmtBLoRF', 'btnTrmtBHiAPCC', 'btnTrmtBHiFVIIIa', 'btnTrmtvW', 'btnTrmtDesmopressin', 'btnTrmtvWFVIII'];
		publicFunctions.hideElements(treatments_to_hide);
		var treatments_to_show = [];
		publicFunctions.showElements(treatments_to_show);

		offsetCounter++;
		//offsetTimeline.play();
		offsetTimeline2.play();
	},

	runNormal: function runNormal(){
		publicFunctions.showAllGears();

		publicFunctions.resetTimelines();

		publicFunctions.resetConditionState();

		publicFunctions.defaultScaleDown();

////// Animations

		// variables.normalTimeline.add(variables.r8Timeline);
		 variables.normalTimeline.to(belt_full, 0, {autoAlpha: 0, display: 'none', delay:0}, 0);
		 variables.normalTimeline.to(belt_broken, 0, {autoAlpha: 0, display: 'none', delay:0}, 0);
		 variables.normalTimeline.to(factor_12_div, .5, {scale: 1, delay: 0}, 0);
		 variables.normalTimeline.to(factor_12, 9, {rotation: -3240, ease: Power0.easeNone, delay: 0.5}, 0);
		 variables.normalTimeline.to(grey_gear_01, 9, {rotation: 3240, ease: Power0.easeNone, delay: 0.5}, 0);
		 variables.normalTimeline.to(factor_11_div, .5, {scale: 1, delay: 1}, 0);
		 variables.normalTimeline.to(factor_11, 8, {rotation: -2880, ease: Power0.easeNone, delay: 1.5}, 0);
		 variables.normalTimeline.to(small_gear_01, 8, {rotation: 2880, ease: Power0.easeNone, delay: 1.5}, 0);
		 variables.normalTimeline.to(factor_09_div, .5, {scale: 1, delay: 2}, 0);
		 variables.normalTimeline.to(factor_09, 7, {rotation: -2520, ease: Power0.easeNone, delay: 2.5}, 0);
		 variables.normalTimeline.to(grey_gear_02, 7, {rotation: 2520, ease: Power0.easeNone, delay: 2.5}, 0);
		 variables.normalTimeline.to(factor_08_div, .5, {scale: 1, delay: 3}, 0);
		 variables.normalTimeline.to(factor_vW_div, .5, {scale: 1, delay: 3}, 0);
		 variables.normalTimeline.to(factor_08, 6, {rotation: -2160, ease: Power0.easeNone, delay: 3.5}, 0);
		 variables.normalTimeline.to(factor_vW, 6, {rotation: -2160, ease: Power0.easeNone, delay: 3.5}, 0);
		 variables.normalTimeline.to(grey_gear_08, 6, {rotation: 2160, ease: Power0.easeNone, delay: 3.5}, 0);
		 variables.normalTimeline.to(factor_10_div, .5, {scale: 1, delay: 4}, 0);
		 variables.normalTimeline.to(factor_10, 5, {rotation: -1800, ease: Power0.easeNone, delay: 4.5}, 0);
		 variables.normalTimeline.to(grey_gear_06, 5, {rotation: 1800, ease: Power0.easeNone, delay: 4.5}, 0);
		 variables.normalTimeline.to(grey_gear_07, 5, {rotation: -1800, ease: Power0.easeNone, delay: 4.5}, 0);
		 variables.normalTimeline.to(grey_gear_03, 5, {rotation: 1800, ease: Power0.easeNone, delay: 4.5}, 0);
		 variables.normalTimeline.to(small_gear_02, 5, {rotation: 1800, ease: Power0.easeNone, delay: 4.5}, 0);
		 variables.normalTimeline.to(factor_07a_div, .5, {scale: 1, delay: 5}, 0);
		 variables.normalTimeline.to(factor_05a_div, .5, {scale: 1, delay: 5}, 0);
		 variables.normalTimeline.to(factor_07a, 4, {rotation: -1440, ease: Power0.easeNone, delay: 5.5}, 0);
		 variables.normalTimeline.to(factor_05a, 4, {rotation: -1440, ease: Power0.easeNone, delay: 5.5}, 0);
		 variables.normalTimeline.to(grey_gear_04, 4, {rotation: 1440, ease: Power0.easeNone, delay: 5.5}, 0);
		 variables.normalTimeline.to(factor_02a_div, .5, {scale: 1, delay: 6}, 0);
		 variables.normalTimeline.to(factor_02a, 3, {rotation: -1080, ease: Power0.easeNone, delay: 6.5}, 0);
		 variables.normalTimeline.to(small_gear_03, 3, {rotation: 1080, ease: Power0.easeNone, delay: 6.5}, 0);
		 variables.normalTimeline.to(factor_01a_div, .5, {scale: 1, delay: 7}, 0);
		 variables.normalTimeline.to(factor_01a, 2, {rotation: -720, ease: Power0.easeNone, delay: 7.5}, 0);
		 variables.normalTimeline.to(grey_gear_05, 2, {rotation: 720, ease: Power0.easeNone, delay: 7.5}, 0);
		 variables.normalTimeline.to(factor_13a_div, .5, {scale: 1, delay: 8}, 0);
		 variables.normalTimeline.to(factor_13a, 1, {rotation: -360, ease: Power0.easeNone, delay: 8.5}, 0);
		 variables.normalTimeline.to(small_gear_04, 1, {rotation: 360, ease: Power0.easeNone, delay: 8.5}, 0);
		 variables.normalTimeline.to(factor_CLOT, 1, {rotation: -360, ease: Power0.easeNone, delay: 8.5}, 0);
		 variables.normalTimeline.to(factor_CLOT, .5, {fill: "#00C7B1", delay: 9}, 0);
		 variables.normalTimeline.to(belt_full, .5, {autoAlpha: 1, display: 'block', delay: 9}, 0);
		 variables.normalTimeline.to(belt_broken, .5, {autoAlpha: 0, display: 'none', delay: 9}, 0);
		 variables.normalTimeline.to([factor_12, factor_11, factor_09, factor_07a, factor_08, factor_10, factor_05a, factor_02a, factor_01a, factor_13a, factor_CLOT, grey_gear_07], 100, {rotation: -36000, ease: Power0.easeNone, delay: 9.5, repeat:-1}, 0);
		 variables.normalTimeline.to([factor_vW, grey_gear_01, grey_gear_02, grey_gear_03, grey_gear_04, grey_gear_05, grey_gear_06, grey_gear_08, small_gear_01, small_gear_02, small_gear_03, small_gear_04], 100, {rotation: 36000, ease: Power0.easeNone, delay: 9.5, repeat:-1}, 0);

//////

		variables.counters.normalCounter++;
		variables.normalTimeline.play();
	},

	showAllGears: function showAllGears(){
		$( "#factor_12_div" ).show();
		$( "#factor_11_div" ).show();
		$( "#factor_09_div" ).show();
		$( "#factor_07a_div" ).show();
		$( "#factor_08_div" ).show();
		$( "#factor_vW_div" ).show();
		$( "#factor_10_div" ).show();
		$( "#factor_05a_div" ).show();
		$( "#factor_02a_div" ).show();
		$( "#factor_01a_div" ).show();
		$( "#factor_13a_div" ).show();
		$( "#factor_CLOT_div" ).show();

		$( "#grey_gear_01" ).show();
		$( "#grey_gear_02" ).show();
		$( "#grey_gear_03" ).show();
		$( "#grey_gear_04" ).show();
		$( "#grey_gear_05" ).show();
		$( "#grey_gear_06" ).show();
		$( "#grey_gear_07" ).show();
		$( "#grey_gear_08" ).show();
		$( "#grey_gear_09" ).show();

		$( "#small_gear_01" ).show();
		$( "#small_gear_02" ).show();
		$( "#small_gear_03" ).show();
		$( "#small_gear_04" ).show();

		document.getElementById('belt_full').style.display='block';
		document.getElementById('factor_08_div').style.display='block';
		document.getElementById('factor_09_div').style.display='block';
		document.getElementById('factor_08').style.display='block';
		document.getElementById('factor_09').style.display='block';
		document.getElementById('factor_vW_div').style.display='block';
		document.getElementById('factor_vW').style.display='block';
		TweenLite.to(factor_08_div, 0, {autoAlpha: 1, display: 'block', delay: 0});
		TweenLite.to(factor_09_div, 0, {autoAlpha: 1, display: 'block', delay: 0});
		TweenLite.to(factor_vW_div, 0, {autoAlpha: 1, display: 'block', delay: 0});
		document.getElementById('belt_broken').style.display='none';
		$("#hemA_Low").hide();
		$("#hemA_Hi").hide();
		$("#hemB_Low").hide();
		$("#hemB_Hi").hide();

		$("#factor_10_activated").css({"display": "none"});
		$("#factor_7a_activated").css({"display": "none"});
		$("#factor_08_activated").css({"display": "none"});
		$("#factor_replacement_08_activated").css({"display": "none"});
		$("#factor_replacement_09_activated").css({"display": "none"});
		$("#factor_08_thin").css({"display": "none"});
		$("#factor_8_extra").css({"display": "none"});
		$("#factor_vW_extra").css({"display": "none"});

		$("#clot_label").css({"color": "#ED1C24"});

		publicFunctions.defaultOpenInfoBox();
	},

	resetTimelines: function resetTimelines(){
		publicFunctions.resetTreatmentFactors();
		variables.offsetTimeline.pause(0, true);
		variables.offsetTimeline.remove();
		variables.offsetTimeline.invalidate();

		variables.normalTimeline.pause(0, true);
		variables.normalTimeline.remove();
		variables.normalTimeline.invalidate();

		variables.hemATimeline.pause(0, true);
		variables.hemATimeline.remove();
		variables.hemATimeline.invalidate();

		variables.hemALowTimeline.pause(0, true);
		variables.hemALowTimeline.remove();
		variables.hemALowTimeline.invalidate();

		variables.hemAHighTimeline.pause(0, true);
		variables.hemAHighTimeline.remove();
		variables.hemAHighTimeline.invalidate();

		variables.hemBTimeline.pause(0, true);
		variables.hemBTimeline.remove();
		variables.hemBTimeline.invalidate();

		variables.hemBLowTimeline.pause(0, true);
		variables.hemBLowTimeline.remove();
		variables.hemBLowTimeline.invalidate();

		variables.hemBHighTimeline.pause(0, true);
		variables.hemBHighTimeline.remove();
		variables.hemBHighTimeline.invalidate();

		variables.vWTimeline.pause(0, true);
		variables.vWTimeline.remove();
		variables.vWTimeline.invalidate();

		variables.hemARFTimeline.pause(0, true);
		variables.hemARFTimeline.remove();
		variables.hemARFTimeline.invalidate();

		variables.hemAHiApccTimeline.pause(0, true);
		variables.hemAHiApccTimeline.remove();
		variables.hemAHiApccTimeline.invalidate();

		variables.hemAHi7Timeline.pause(0, true);
		variables.hemAHi7Timeline.remove();
		variables.hemAHi7Timeline.invalidate();

		variables.hemBRFTimeline.pause(0, true);
		variables.hemBRFTimeline.remove();
		variables.hemBRFTimeline.invalidate();

		variables.hemBHi7Timeline.pause(0, true);
		variables.hemBHi7Timeline.remove();
		variables.hemBHi7Timeline.invalidate();

		variables.hemBHiApccTimeline.pause(0, true);
		variables.hemBHiApccTimeline.remove();
		variables.hemBHiApccTimeline.invalidate();

		variables.vWRFTimeline.pause(0, true);
		variables.vWRFTimeline.remove();
		variables.vWRFTimeline.invalidate();

		variables.vWRFVIIITimeline.pause(0, true);
		variables.vWRFVIIITimeline.remove();
		variables.vWRFVIIITimeline.invalidate();

		variables.vWDesmopressinTimeline.pause(0, true);
		variables.vWDesmopressinTimeline.remove();
		variables.vWDesmopressinTimeline.invalidate();
	},

	resetConditionState: function resetConditionState(){
		TweenLite.to(factor_CLOT, 0, {fill: "#00c7b1", delay: 0});
		TweenLite.to(factor_08, 0, {fill: "#00c7b1", delay: 0});
		TweenLite.to(factor_09, 0, {fill: "#00c7b1", delay: 0});
		TweenLite.to(factor_vW, 0, {fill: "#00c7b1", delay: 0});
		TweenLite.to(factor_vW_extra, 0, {stroke: "#cbf3ee", delay: 0});
		TweenLite.to(factor_08_div, 0, {autoAlpha: 1, display: 'block', delay: 0});
		TweenLite.to(factor_09_div, 0, {autoAlpha: 1, display: 'block', delay: 0});
		TweenLite.to(factor_vW_div, 0, {autoAlpha: 1, display: 'block', delay: 0});

		document.getElementById('belt_full').style.display='block';
		document.getElementById('belt_broken').style.display='none';
		$("#hemA_Low").hide();
		$("#hemA_Hi").hide();
		$("#hemB_Low").hide();
		$("#hemB_Hi").hide();
	},

	resetTreatmentFactors: function resetTreatmentFactors(){
		$("#factor_replacement_08_div").css({"display": "none"});
		$("#factor_replacement_08_div").css({"top": "400px", "left": "108px"});

		$("#factor_replacement_09_div").css({"display": "none"});
		$("#factor_replacement_09_div").css({"top": "400px", "left": "108px"});

		$("#factor_replacement_vW_div").css({"display": "none"});
		$("#factor_replacement_vW_div").css({"top": "400px", "left": "108px"});

		$("#factor_10_activated").css({"display": "none"});
		$("#factor_7a_activated").css({"display": "none"});
		$("#factor_08_activated").css({"display": "none"});
		$("#factor_08_thin").css({"display": "none"});
		$("#factor_8_extra").css({"display": "none"});
		$("#factor_9_extra").css({"display": "none"});
		$("#factor_vW_extra").css({"display": "none"});

		$("#clot_label").css({"color": "#ED1C24"});
	},


	hideGears: function hideGears(gears_to_hide){
		for  (i = 0; i < gears_to_hide.length; i++){
			document.getElementById(gears_to_hide[i] + "_div").style.display='none';
		}
	},

	hideElements: function hideElements(elements_to_hide){
		for  (var i = 0; i < elements_to_hide.length; i++){
			document.getElementById(elements_to_hide[i]).style.display='none';
		}
	},

	showElements: function showElements(elements_to_show){
		for  (var i = 0; i < elements_to_show.length; i++){
			document.getElementById(elements_to_show[i]).style.display='block';
		}
	},

	hideAllInhibitors: function (){
		let inhibitors_to_hide = ['btnHemA_LowTiter','btnHemA_HiTiter','btnHemB_LowTiter','btnHemB_HiTiter','btn_NoTiter'];
		for  (var i = 0; i < inhibitors_to_hide.length; i++){
			document.getElementById(inhibitors_to_hide[i]).style.display='none';
		}
	},

	hideAllTreatments: function (){
		let treatments_to_hide =['btnTrmtAaRF','btnTrmtALoRF','btnTrmtAHiAPCC', 'btnTrmtAHiFVIIIa', 'btnTrmtBaRF', 'btnTrmtBLoRF', 'btnTrmtBHiAPCC', 'btnTrmtBHiFVIIIa', 'btnTrmtvW', 'btnTrmtDesmopressin','btnTrmtvWFVIII'];
		for  (var i = 0; i < treatments_to_hide.length; i++){
			document.getElementById(treatments_to_hide[i]).style.display='none';
		}
	},

	unselectAllConditions : () => {
		var conditionsBtns = document.querySelectorAll('#panel_conditions-section button');
		for(var i = 0; i<conditionsBtns.length; i++){
			conditionsBtns[i].classList.remove('panel_btn--selected');
		}
	},

	unselectAllInhibitors : () => {
		var inhibitorsBtns = document.querySelectorAll('#panel_inhibitors-section button');
		for(var i = 0; i<inhibitorsBtns.length; i++){
			inhibitorsBtns[i].classList.remove('panel_btn--selected');
		}
	},

	unselectAllTreatments : () => {
		var treatmentsBtns = document.querySelectorAll('#panel_treatments-section button');
		for(var i = 0; i<treatmentsBtns.length; i++){
			treatmentsBtns[i].classList.remove('panel_btn--selected');
		}
	},

	startGearsAnimation : (e) => {
		if(document.querySelector('.panel_go-btn .gear').style.cursor === "pointer"){
			publicFunctions.resetTimelines();
			let buttonsClicked = variables.conditionSelected;
			if (buttonsClicked.condition === 'btnvWD' ||
		   	(buttonsClicked.condition !== 'btnvWD' && buttonsClicked.inhibitor !== '')){
				publicFunctions.switchGearsAnimation(buttonsClicked);
			}
		}
	},

	switchGearsAnimation : (buttonsClicked) => {
		switch(buttonsClicked.condition){
			case 'btnHemA':
				switch(buttonsClicked.inhibitor){
					case 'btnHemA_LowTiter':
						switch(buttonsClicked.treatment){
							case 'btnTrmtALoRF':
								treatments.runTrmtALoRF(true);
								break;
							case '':
								//runTrmtvW display a extra border
								inhibitors.runHemA_LowTiter();
								break;
						}
						break;
					case 'btnHemA_HiTiter':
						switch(buttonsClicked.treatment){
							case 'btnTrmtAHiAPCC':
								treatments.runTrmtAHiAPCC();
								break;
							case 'btnTrmtAHiFVIIIa':
								treatments.runTrmtAHiFVIIIa();
								break;
							case '':
								//runTrmtvW doesn't display a extra border
								inhibitors.runHemA_HiTiter();
								break;
						}
						break;
					case 'btn_NoTiter':
						switch(buttonsClicked.treatment){
							case 'btnTrmtAaRF':
								treatments.runTrmtAaRF(false);
								break;
							case '':
								conditions.runHemA();
								break;
						}
						break;
					default:
						break;
				}
			break;
			case 'btnHemB':
				switch(buttonsClicked.inhibitor){
					case 'btnHemB_LowTiter':
						switch(buttonsClicked.treatment){
							case 'btnTrmtBLoRF':
								treatments.runTrmtBaRF(true);
								break;
							case '':
								//runTrmtvW display a extra border
								inhibitors.runHemB_LowTiter();
								break;
						}
						break;
					case 'btnHemB_HiTiter':
						switch(buttonsClicked.treatment){
							case 'btnTrmtBHiAPCC':
								treatments.runTrmtBHiAPCC();
								break;
							case 'btnTrmtBHiFVIIIa':
								treatments.runTrmtBHiFVIIIa();
								break;
							case '':
								//runTrmtvW doesn't display a extra border
								inhibitors.runHemB_HiTiter();
								break;
						}
						break;
					case 'btn_NoTiter':
						switch(buttonsClicked.treatment){
							case 'btnTrmtBaRF':
								treatments.runTrmtBaRF(false);
								break;
							case '':
								conditions.runHemB();
								break;
						}
						break;
				}
			break;
			case 'btnvWD':
				switch(buttonsClicked.treatment){
					case 'btnTrmtDesmopressin':
						treatments.runTrmtDesmopressin();
						break;
					case 'btnTrmtvWFVIII':
						//runTrmtvW display a extra border
						treatments.runTrmtvW(true);
						break;
					case 'btnTrmtvW':
						//runTrmtvW doesn't display a extra border
      					treatments.runTrmtvW(false);
						break;
					case '':
						conditions.runvWD();
						break;
				}
			break;
		}
		publicFunctions.hideControlsPanel();
	},

	hideControlsPanel : () => {
		$(".panel_switch-view, .panel_section-container").removeClass("panel_show");
		switchDownArrow.classList.add("arrow-btn_hide");
  		switchUpArrow.classList.remove("arrow-btn_hide");
	},

	showControlsPanel : () => {
		$(".panel_switch-view, .panel_section-container").addClass("panel_show");
		switchUpArrow.classList.add("arrow-btn_hide");
		switchDownArrow.classList.remove("arrow-btn_hide");

		publicFunctions.closeOpenInfoBox();
	},

	// This function show or hidde the default info
 	displayNoneOrBlockInfoDefault : (data) => {
		if (data === 'none') {
		$("#info-center div").css({ "display": "none" });
		} else {
		$("#info-center div").css({ "display": "block" });
		}
	},

	startWelcomeCarrousel : () => {
		var fadeSpeed = 330;
		$(".welcome-frame").fadeOut( fadeSpeed );
		$(".corrousel-index_container").fadeIn( fadeSpeed );
		$(".corrousel-frame_1").fadeIn( fadeSpeed );
		$(".welcome-carrousel").fadeIn( fadeSpeed );
		$(".btn-carrousel--next").removeClass("initial-hidden");
		$('.index_1').css('color','#56575A');
	},

	moveWelcomeCarrousel: (e) => {

		var isNext = e.target.classList.contains('btn-carrousel--next');
		if(isNext){
			if(variables.counters.carrouselFrameIndexCounter !== 2 || variables.counters.innerCarrouselFrameIndexCounter === 3){
				variables.counters.carrouselFrameIndexCounter++;
			} else {
				variables.counters.innerCarrouselFrameIndexCounter++;
			}
		}
		else {
			if(variables.counters.carrouselFrameIndexCounter !== 2 || variables.counters.innerCarrouselFrameIndexCounter === 1){
				variables.counters.carrouselFrameIndexCounter--;
			} else {
				variables.counters.innerCarrouselFrameIndexCounter--;
			}
		}

		publicFunctions.hightlightFrameIndex();
		publicFunctions.switchCarrouselButtons();
		publicFunctions.switchCarrouselFrames();
	},

	hightlightFrameIndex: () => {
		switch(variables.counters.carrouselFrameIndexCounter){
			case 1:
				$('.index_1').css('color','#56575A');
				$('.index_2').css('color','');
				$('.index_3').css('color','');
				break;
			case 2:
				$('.index_1').css('color','');
				$('.index_2').css('color','#56575A');
				$('.index_3').css('color','');
				break;
			case 3:
				$('.index_1').css('color','');
				$('.index_2').css('color','');
				$('.index_3').css('color','#56575A');
				break;
		}
	},

	switchCarrouselButtons: () =>{
		switch(variables.counters.carrouselFrameIndexCounter){
			case 1:
				$(".btn-carrousel--back").addClass("initial-hidden");
				break;
			case 2:
				$(".btn-carrousel--back").removeClass("initial-hidden");
				$(".btn-carrousel--next").removeClass("initial-hidden");
				$(".btn-carrousel--start").addClass("initial-hidden");
				break;
			case 3:
				$(".btn-carrousel--next").addClass("initial-hidden");
				$(".btn-carrousel--start").removeClass("initial-hidden");
				break;
		}
	},

	switchCarrouselFrames: () =>{
		var fadeSpeed = 330;
		switch(variables.counters.carrouselFrameIndexCounter){
			case 1:
			    $('.corrousel-frame_2').fadeOut( fadeSpeed );
				$('.corrousel-frame_1').fadeIn( fadeSpeed );
				break;
			case 2:
				$('.corrousel-frame_1').fadeOut( fadeSpeed );
				$('.corrousel-frame_3').fadeOut( fadeSpeed );
				$('.corrousel-frame_2').fadeIn( fadeSpeed );
				publicFunctions.switchInnerCarrouselFrames();
				break;
			case 3:
				$('.corrousel-frame_2').fadeOut( fadeSpeed );
				$('.corrousel-frame_3').fadeIn( fadeSpeed );
				break;
		}
	},

	switchInnerCarrouselFrames: () => {
		var fadeSpeed = 330;
		switch(variables.counters.innerCarrouselFrameIndexCounter){
			case 1:
				$('.inner_corrousel-frame_3').fadeOut( fadeSpeed );
				$('.inner_corrousel-frame_2').fadeOut( fadeSpeed );
				$('.inner_corrousel-frame_1').fadeIn( fadeSpeed );
				break;
			case 2:
				$('.inner_corrousel-frame_1').fadeOut( fadeSpeed );
				$('.inner_corrousel-frame_3').fadeOut( fadeSpeed );
				$('.inner_corrousel-frame_2').fadeIn( fadeSpeed );
				break;
			case 3:
				$('.inner_corrousel-frame_1').fadeOut( fadeSpeed );
				$('.inner_corrousel-frame_2').fadeOut( fadeSpeed );
				$('.inner_corrousel-frame_3').fadeIn( fadeSpeed );
				break;
		}

	},

	showInfoModal: (e) => {
		variables.isInWelcome = document.querySelector('.modal-welcome').style.display !== 'none';
		publicFunctions.hideWelcomeModal();
		document.querySelector('.modal').style.display ='block';
		document.querySelector('.modal-info').style.display ='block';
		publicFunctions.selectInfoModal(e.target.innerText)
		$('.modal-info-description strong').click((publicFunctions.showInfoModal));
	},

	selectInfoModal: (title) => {
		switch(title){
			case 'coagulation':
				document.querySelector('.modal-info h2').innerHTML = infoContent.glossary.coagulation.title;
				document.querySelector('.modal-info p').innerHTML = infoContent.glossary.coagulation.description;
				break;
			case 'bleed':
			case 'bleeding episodes':
				document.querySelector('.modal-info h2').innerHTML = infoContent.glossary.bleed_bleedingEpisodes.title;
				document.querySelector('.modal-info p').innerHTML = infoContent.glossary.bleed_bleedingEpisodes.description;
				break;
			case 'platelets':
				document.querySelector('.modal-info h2').innerHTML = infoContent.glossary.platelets.title;
				document.querySelector('.modal-info p').innerHTML = infoContent.glossary.platelets.description;
				break;
			case 'bleeding disorder':
				document.querySelector('.modal-info h2').innerHTML = infoContent.glossary.bleedingDisorder.title;
				document.querySelector('.modal-info p').innerHTML = infoContent.glossary.bleedingDisorder.description;
				break;
			case 'platelet plug':
			case 'platelet plugs':
				document.querySelector('.modal-info h2').innerHTML = infoContent.glossary.plateletPlug.title;
				document.querySelector('.modal-info p').innerHTML = infoContent.glossary.plateletPlug.description;
				break;
			case 'genetic disorder':
				document.querySelector('.modal-info h2').innerHTML = infoContent.glossary.geneticDisorder.title;
				document.querySelector('.modal-info p').innerHTML = infoContent.glossary.geneticDisorder.description;
				break;
			case 'immune system':
				document.querySelector('.modal-info h2').innerHTML = infoContent.glossary.immuneSystem.title;
				document.querySelector('.modal-info p').innerHTML = infoContent.glossary.immuneSystem.description;
				break;
			case 'antibodies (inhibitors)':
			case 'antibodies':
			case 'inhibitors':
				document.querySelector('.modal-info h2').innerHTML = infoContent.glossary.antibodies_inhibitors.title;
				document.querySelector('.modal-info p').innerHTML = infoContent.glossary.antibodies_inhibitors.description;
				break;
			case 'high-titer inhibitors':
				document.querySelector('.modal-info h2').innerHTML = infoContent.glossary.highTiterInhibitor.title;
				document.querySelector('.modal-info p').innerHTML = infoContent.glossary.highTiterInhibitor.description;
				break;
			case 'low-titer inhibitors':
				document.querySelector('.modal-info h2').innerHTML = infoContent.glossary.lowTiterInhibitor.title;
				document.querySelector('.modal-info p').innerHTML = infoContent.glossary.lowTiterInhibitor.description;
				break;
			case 'intrinsic':
			case 'intrinsic pathway':
				document.querySelector('.modal-info h2').innerHTML = infoContent.glossary.intrinsicPathway.title;
				document.querySelector('.modal-info p').innerHTML = infoContent.glossary.intrinsicPathway.description;
				break;
			case 'extrinsic pathways':
			case 'extrinsic pathway':
				document.querySelector('.modal-info h2').innerHTML = infoContent.glossary.extrinsicPathway.title;
				document.querySelector('.modal-info p').innerHTML = infoContent.glossary.extrinsicPathway.description;
				break;
			case 'blood clot':
				document.querySelector('.modal-info h2').innerHTML = infoContent.glossary.bloodClot.title;
				document.querySelector('.modal-info p').innerHTML = infoContent.glossary.bloodClot.description;
				break;
			case 'coagulation cascade':
				document.querySelector('.modal-info h2').innerHTML = infoContent.glossary.coagulationCascade.title;
				document.querySelector('.modal-info p').innerHTML = infoContent.glossary.coagulationCascade.description;
				break;
			case 'Fibrin':
			case 'fibrin':
				document.querySelector('.modal-info h2').innerHTML = infoContent.glossary.fibrin.title;
				document.querySelector('.modal-info p').innerHTML = infoContent.glossary.fibrin.description;
				break;
			case 'common pathway':
				document.querySelector('.modal-info h2').innerHTML = infoContent.glossary.commonPathway.title;
				document.querySelector('.modal-info p').innerHTML = infoContent.glossary.commonPathway.description;
				break;
			case 'thrombin burst':
				document.querySelector('.modal-info h2').innerHTML = infoContent.glossary.thrombinBurst.title;
				document.querySelector('.modal-info p').innerHTML = infoContent.glossary.thrombinBurst.description;
				break;
			case 'hemostasis':
				document.querySelector('.modal-info h2').innerHTML = infoContent.glossary.hemostasis.title;
				document.querySelector('.modal-info p').innerHTML = infoContent.glossary.hemostasis.description;
				break;
			case 'factor XII':
				document.querySelector('.modal-info h2').innerHTML = infoContent.factors.factorXII.title;
				document.querySelector('.modal-info p').innerHTML = infoContent.factors.factorXII.description;
				break;
			case 'factor XI':
				document.querySelector('.modal-info h2').innerHTML = infoContent.factors.factorXI.title;
				document.querySelector('.modal-info p').innerHTML = infoContent.factors.factorXI.description;
				break;
			case 'factor IX':
				document.querySelector('.modal-info h2').innerHTML = infoContent.factors.factorIX.title;
				document.querySelector('.modal-info p').innerHTML = infoContent.factors.factorIX.description;
				break;
			case 'factor VIII':
				document.querySelector('.modal-info h2').innerHTML = infoContent.factors.factorVIII.title;
				document.querySelector('.modal-info p').innerHTML = infoContent.factors.factorVIII.description;
				break;
			case 'factor X':
				document.querySelector('.modal-info h2').innerHTML = infoContent.factors.factorX.title;
				document.querySelector('.modal-info p').innerHTML = infoContent.factors.factorX.description;
				break;
			case 'clot':
				document.querySelector('.modal-info h2').innerHTML = infoContent.factors.clot.title;
				document.querySelector('.modal-info p').innerHTML = infoContent.factors.clot.description;
				break;
			case 'hemophilia A':
				document.querySelector('.modal-info h2').innerHTML = infoContent.conditions.hemophiliaA.title;
				document.querySelector('.modal-info p').innerHTML = infoContent.conditions.hemophiliaA.description;
				break;
			case 'hemophilia B':
				document.querySelector('.modal-info h2').innerHTML = infoContent.conditions.hemophiliaB.title;
				document.querySelector('.modal-info p').innerHTML = infoContent.conditions.hemophiliaB.description;
				break;
			case 'von Willebrand disease':
				document.querySelector('.modal-info h2').innerHTML = infoContent.conditions.vWDisease.title;
				document.querySelector('.modal-info p').innerHTML = infoContent.conditions.vWDisease.description;
				break;
			case 'factor':
				document.querySelector('.modal-info h2').innerHTML = infoContent.glossary.factor.title;
				document.querySelector('.modal-info p').innerHTML = infoContent.glossary.factor.description;
				break;
			case 'replacement factor':
				document.querySelector('.modal-info h2').innerHTML = infoContent.glossary.replacementFactor.title;
				document.querySelector('.modal-info p').innerHTML = infoContent.glossary.replacementFactor.description;
				break;
			default:
				document.querySelector('.modal-info h2').innerHTML = title;
				document.querySelector('.modal-info p').innerHTML = 'No Info';
				break;
		}
	},

	hideWelcomeModal: () => {
		document.querySelector('.modal').style.display = 'none';
		document.querySelector('.modal-welcome').style.display = 'none';
	},

	showWelcomeModal: () => {
		variables.counters.carrouselFrameIndexCounter = 1;
		variables.counters.innerCarrouselFrameIndexCounter = 1;

		document.querySelector('.welcome-carrousel').style.display = 'none';

		document.querySelector('.btn-carrousel--back').classList.add("initial-hidden");
		document.querySelector('.btn-carrousel--next').classList.add("initial-hidden");
		document.querySelector('.btn-carrousel--start').classList.add("initial-hidden");
		$('.index_3').css('color','#E2E2E2');

		document.querySelector('.corrousel-frame_2').style.display = 'none';
		document.querySelector('.corrousel-frame_3').style.display = 'none';
		document.querySelector('.corrousel-frame_1').style.display = 'block';

		publicFunctions.hightlightFrameIndex();
		publicFunctions.switchCarrouselButtons();
		publicFunctions.switchCarrouselFrames();

		document.querySelector('.welcome-frame').style.display = 'block';
		document.querySelector('.modal').style.display = 'block';
		document.querySelector('.modal-welcome').style.display = 'block';
	},

	hideInfoModal: () => {
		document.querySelector('.modal-info').style.display = 'none';
		if(variables.isInWelcome){
			document.querySelector('.modal-welcome').style.display = 'block';
		}else {
			document.querySelector('.modal').style.display = 'none';
		}

	},

	showGlossaryModal: () => {
		publicFunctions.showGlossaryPage();
		document.querySelector('.modal').style.display = 'block';
		document.querySelector('.modal-glossary').classList.remove('initial-hidden');
		document.querySelector('.modal-glossary_close').classList.remove('initial-hidden');
	},

	hideGlossaryModal: () => {
		variables.arrayGlossaryPages[variables.counters.glossaryPage].classList.add('initial-hidden');
		variables.counters.glossaryPage = 0;

		document.querySelector('.glossary-nav--back').classList.add('initial-hidden');
		document.querySelector('.glossary-nav--next').classList.remove('initial-hidden');

		document.querySelector('.modal-glossary').classList.add('initial-hidden');
		document.querySelector('.modal-glossary_close').classList.add('initial-hidden');
		document.querySelector('.modal').style.display = 'none';
	},

	//This function is not being used for now.

	// showGearOptions: (e) => {
	// 	var optionsBox = document.querySelector('.gears-options-box'),
	// 		info = optionsBox.querySelector('.options .info'),
	// 		c = document.getElementById("myCanvas"),
	// 		ctx = c.getContext("2d"),
	// 		parentElement = e.currentTarget.parentNode,
	// 		optionsBoxPosX,
	// 		optionsBoxPosY,
	// 		gearPosX,
	// 		gearPosY;

	// 	ctx.clearRect(0, 0, c.width, c.height);
	// 	variables.factorSelected = e.currentTarget.id;
	// 	optionsBox.style.display = 'block';

	// 	publicFunctions.positionOptionsBox(
	// 		optionsBox,
	// 		parentElement.getBoundingClientRect().left - parentElement.getBoundingClientRect().width,
	// 		parentElement.getBoundingClientRect().bottom + parentElement.getBoundingClientRect().height,
	// 		e.currentTarget.id
	// 	);




	// 	gearPosX = parentElement.getBoundingClientRect().left;
	// 	gearPosY = parentElement.getBoundingClientRect().bottom - parentElement.getBoundingClientRect().height / 2;
	// 	optionsBoxPosX = optionsBox.offsetLeft + (optionsBox.clientWidth / 2);
	// 	optionsBoxPosY = optionsBox.offsetTop;

	// 	drawArrow(optionsBoxPosX, optionsBoxPosY, gearPosX, gearPosY)

	// 	function drawArrow(fromx, fromy, tox, toy){
	// 		//variables to be used when creating the arrow
	// 		var c = document.getElementById("myCanvas");
	// 		var ctx = c.getContext("2d");
	// 		var headlen = 10;

	// 		var angle = Math.atan2(toy-fromy,tox-fromx);

	// 		//starting path of the arrow from the start square to the end square and drawing the stroke
	// 		ctx.beginPath();
	// 		ctx.moveTo(fromx, fromy);
	// 		ctx.lineTo(tox, toy);
	// 		ctx.strokeStyle = "#00C6AF";
	// 		ctx.lineWidth = 2;
	// 		ctx.stroke();

	// 		//starting a new path from the head of the arrow to one of the sides of the point
	// 		ctx.beginPath();
	// 		ctx.moveTo(tox, toy);
	// 		ctx.lineTo(tox-headlen*Math.cos(angle-Math.PI/7),toy-headlen*Math.sin(angle-Math.PI/7));

	// 		//path from the side point of the arrow, to the other side point
	// 		ctx.lineTo(tox-headlen*Math.cos(angle+Math.PI/7),toy-headlen*Math.sin(angle+Math.PI/7));

	// 		//path from the side point back to the tip of the arrow, and then again to the opposite side point
	// 		ctx.lineTo(tox, toy);
	// 		ctx.lineTo(tox-headlen*Math.cos(angle-Math.PI/7),toy-headlen*Math.sin(angle-Math.PI/7));

	// 		//draws the paths created above
	// 		ctx.strokeStyle = "#00C6AF";
	// 		ctx.lineWidth = 2;
	// 		ctx.stroke();
	// 		ctx.fillStyle = "#00C6AF";
	// 		ctx.fill();
	// 	}
	// },

	positionOptionsBox: (optionsBox, clickPositionX, clickPositionY, gearId) => {



		 if(clickPositionX < 0 ){
		 	clickPositionX += 120;
		 }

		if(clickPositionY > 568 ){
		 	clickPositionY -= 280;
		 	clickPositionX -= 115;
		}

		optionsBox.style.left = (clickPositionX) +'px';
		optionsBox.style.top = (clickPositionY) +'px';

	},

	showGearOptionsInfo: (e) => {

		variables.factorSelected = e.currentTarget.id;

		publicFunctions.displayNoneOrBlockInfoDefault('none')
		publicFunctions.setInfoBoxtoTop();
		var divHeight;
		  switch(variables.factorSelected){
			case 'factor_12':
				$("#info-factor_12").css({ "display": "block" });
				break;
			case 'factor_11':
				$("#info-factor_11").css({ "display": "block" });
				break;
			case 'factor_09':
			case 'factor_replacement_09':
				$("#info-factor_09").css({ "display": "block" });
				variables.factorSelected = 'factor_09';
				break;
			case 'factor_08':
			case 'factor_replacement_08':
				$("#info-factor_08").css({ "display": "block" });
				variables.factorSelected = 'factor_08';
				break;
			case 'factor_vW':
			case 'factor_replacement_vW':
				$("#info-factor_vW").css({ "display": "block" });
				variables.factorSelected = 'factor_vW';
				break;
			case 'factor_10':
				$("#info-factor_10").css({ "display": "block" });
				break;
			case 'factor_05a':
				$("#info-factor_05a").css({ "display": "block" });
				break;
			case 'factor_07a':
				$("#info-factor_07a").css({ "display": "block" });
				break;
			case 'factor_02a':
				$("#info-factor_02a").css({ "display": "block" });
				break;
			case 'factor_01a':
				$("#info-factor_01a").css({ "display": "block" });
				break;
			case 'factor_13a':
				$("#info-factor_13a").css({ "display": "block" });
				break;
			case 'factor_CLOT':
				$("#info-factor_CLOT").css({ "display": "block" });
				break;
		}
		divHeight = $("#info-"+variables.factorSelected).outerHeight();
		$("#info-center").css({ "height": divHeight + 120 });
		$("#info-center_toggle").css({ "top": divHeight + 108 })
		publicFunctions.showInfoBox()
	},

	hideOptionsBox : (e) => {
		var optionsBox = e.currentTarget.parentElement;
		optionsBox.style.display = 'none';
		var c = document.getElementById("myCanvas");
		var ctx = c.getContext("2d");
		ctx.clearRect(0, 0, c.width, c.height);
	},

	toggleInfoBox: () => {
		var infoCenter = document.querySelector("#info-center");
		var divHeight = infoCenter.offsetHeight - 55;
		infoCenter.style.transition = 'transform 500ms'
		if(infoCenter.style.transform === 'translateY('+ divHeight +'px)'){
			infoCenter.style.transform = 'translateY('+ 0 +'px)';
		}else{
			infoCenter.style.transform = 'translateY('+ divHeight +'px)';
		}

	},

	defaultOpenInfoBox: () => {
		var infoCenter = document.querySelector("#info-center");
		var divHeight = infoCenter.offsetHeight - 55;
		infoCenter.style.transition = 'transform 500ms'
		if(infoCenter.style.transform === 'translateY('+ divHeight +'px)'){

		}else{
			infoCenter.style.transform = 'translateY('+ divHeight +'px)';
		}

	},

	closeOpenInfoBox: () => {
		var infoCenter = document.querySelector("#info-center");
		var divHeight = infoCenter.offsetHeight - 55;
		infoCenter.style.transition = 'transform 500ms'
		if(infoCenter.style.transform === 'translateY('+ divHeight +'px)'){
			infoCenter.style.transform = 'translateY('+ 0 +'px)';
		}

	},

	setInfoBoxtoTop: () => {
		var infoCenter = document.querySelector("#info-center");
		var divHeight = infoCenter.offsetHeight - 55;
		if(infoCenter.style.transform !== '' && infoCenter.style.transform !== 'translateY(0px)'){
			infoCenter.style.transition = 'none'
			infoCenter.style.transform = 'translateY('+ divHeight +'px)'
		}
	},

	showInfoBox: () => {
		var infoCenter = document.querySelector("#info-center");
		var divHeight = infoCenter.offsetHeight - 55;
		infoCenter.style.transform = 'translateY('+ divHeight +'px)';
	},

	changeGlossaryPage: (e) => {
		variables.arrayGlossaryPages[variables.counters.glossaryPage].classList.add('initial-hidden');
		if(
			(e.target.classList[0] === 'glossary-nav--back' && variables.counters.glossaryPage === 1) ||
			(e.target.classList[0] === 'glossary-nav--next' && variables.counters.glossaryPage === variables.arrayGlossaryPages.length - 2)
		  ){
			e.target.classList.add('initial-hidden');
		}
		if (e.target.classList[0] === 'glossary-nav--back' && variables.counters.glossaryPage > 0 )	{
			document.querySelector('.glossary-nav--next').classList.remove('initial-hidden');
			variables.counters.glossaryPage--;
		}

		if (e.target.classList[0] === 'glossary-nav--next' && variables.counters.glossaryPage < variables.arrayGlossaryPages.length - 1 )	{
			document.querySelector('.glossary-nav--back').classList.remove('initial-hidden');
			variables.counters.glossaryPage++;
		}
		publicFunctions.showGlossaryPage();
	},

	showGlossaryPage : () => {
		variables.arrayGlossaryPages[variables.counters.glossaryPage].classList.remove('initial-hidden');
	},

	defaultScaleDown: ()=>{
		TweenLite.to([factor_12_div, factor_11_div, factor_09_div, factor_07a_div, factor_08_div, factor_10_div, factor_05a_div, factor_02a_div, factor_01a_div, factor_13a_div, factor_vW_div, factor_replacement_08_div, factor_replacement_09_div, factor_replacement_vW_div], 0, {scale: .8, delay: 0});
	},

	defaultScaleUp: () =>{
		TweenLite.to([factor_12_div, factor_11_div, factor_09_div, factor_07a_div, factor_08_div, factor_10_div, factor_05a_div, factor_02a_div, factor_01a_div, factor_13a_div, factor_vW_div, factor_replacement_08_div, factor_replacement_09_div, factor_replacement_vW_div], 0, {scale: 1, delay: 0});
	},

	refreshAnimations: () => {
		var infoDefault, divHeight;
		infoDefault = document.querySelector("#info-default");

		publicFunctions.displayNoneOrBlockInfoDefault('none')
		infoDefault.style.display = 'block'

		divHeight = infoDefault.offsetHeight;

		$("#info-center").css({ "height": divHeight + 120 });
		$("#info-center_toggle").css({ "top": divHeight + 108 })
		publicFunctions.runNormal();

		publicFunctions.showInfoBox()

		publicFunctions.unselectAllConditions();
		publicFunctions.unselectAllInhibitors();
		publicFunctions.unselectAllTreatments();

		publicFunctions.hideAllInhibitors();
		publicFunctions.hideAllTreatments();

		publicFunctions.resetConditionSelected()
	},

	resetConditionSelected : () => {
		variables.conditionSelected = {
			condition: '',
			inhibitor: '',
			treatment: ''
		}
	},




}
export default publicFunctions;



// WEBPACK FOOTER //
// ./src/js/public-functions.js